import { useEffect, useState } from "react";
import { useLoading } from "../../utils/spinner";
import { Alert, Button, Col, Container, Form, Row } from "react-bootstrap";
import ReactPlayer from "react-player";
import { YOUTUBE_URL_GET_COOKIE } from "../../constants/Common";
import { checkCookie } from "../../services/authService";
import { useNavigate } from "react-router-dom";
import { COOKIE_ERR, EMPTY_COOKIE, LOGIN_AUTO_EXCEPTION } from "../../constants/errMessage";
import { SCREEN_ROUTER } from "../../constants/screenRouter";
import { getLocalStorage } from "../../utils/localStorage";
import { STORAGE_KEY } from "../../constants/storageKeys";
import useIsLoginAccountStore from "../../hooks/useLoginAccount";
import nextScreen from "../../utils/navigateScreen";

const LoginCookie = () => {
    const [inputCookie, setInputCookie] = useState('');
    const [errorMessage, setErrorMessage] = useState(""); // Trạng thái để lưu lỗi
    const { setLoading } = useLoading();
    const navigate = useNavigate();
    const { isLoginAccount, setIsLoginAccount } = useIsLoginAccountStore()
    const handleSubmit = (e) => {
        e.preventDefault();
        if (inputCookie == null || inputCookie == '') {
            setErrorMessage(EMPTY_COOKIE)
            return;
        }
        // const expiresMatch = inputCookie.match(/Expires=([^;]+)/);
        // if (!expiresMatch) {
        //     setErrorMessage(COOKIE_ERR)
        //     return;
        // }
        // const expiresTime = new Date(expiresMatch[1]);
        // if (expiresTime.getTime() <= new Date().getTime()) {
        //     setErrorMessage(COOKIE_ERR)
        //     return;
        // }
        setLoading(true);
        checkCookie(inputCookie).then((resolve) => {
            if (resolve === true) {
                navigate(SCREEN_ROUTER.DASH_BOARD)
            } else if (resolve == -1) {
                
                navigate(nextScreen(SCREEN_ROUTER.LOGIN_TOKEN))
            }
            else {
                setErrorMessage(COOKIE_ERR)
            }
        }).catch((e) => {
            setErrorMessage(LOGIN_AUTO_EXCEPTION)
        }).finally(() => {
            setIsLoginAccount(false);
            setLoading(false);
        })

    };

    useEffect(() => {
        navigate(nextScreen(SCREEN_ROUTER.LOGIN_COOKIE))
    }, [])

    return (
        <>
            <Container className="mt-3 d-flex justify-content-center">
                <Row className="w-100">
                    <Col xs={12} md={8} lg={6} className="mx-auto">
                        <Form className="shadow p-4 bg-white rounded" onSubmit={handleSubmit}>
                            {/* Header */}
                            <div className="h4 mb-2 text-center">Nhập Cookie</div>

                            {/* Hiển thị lỗi */}
                            {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}

                            <Form.Group className="mb-2" controlId="cookie">
                                <Form.Control
                                    type="text"
                                    value={inputCookie}
                                    placeholder="Nhập cookie"
                                    onChange={(e) => setInputCookie(e.target.value)}
                                    required
                                />
                            </Form.Group>
                            <Button className="mx-auto" variant="primary" disabled={!inputCookie} type="submit">
                                Kiểm tra
                            </Button>
                        </Form>
                    </Col>
                </Row>
            </Container>
            <Container className="mt-3 text-center">
                {/* Hàng chứa tiêu đề */}
                <Row className="justify-content-center">
                    <Col xs={12}>
                        <div className="h5 mb-3">Hướng dẫn cách lấy cookie</div>
                    </Col>
                </Row>

                {/* Hàng chứa video */}
                <Row className="justify-content-center">
                    <Col xs={12} md={8} lg={6}>
                        <ReactPlayer url={YOUTUBE_URL_GET_COOKIE} controls={true} width="100%" />
                    </Col>
                </Row>
            </Container>
        </>
    );
}
export default LoginCookie